export default __webpack_public_path__ + "static/banner_placeholder-1969bbfca4c4b9e5a5e559cbf24f644a.jpg";